import { Component, EventEmitter, Input, Output  } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';

import { ResetpassService } from './resetpass.service';

//  Jquery imports
// import * as jquery from 'jquery';
declare var jquery:any;
declare var $:any;

@Component({
	selector: 'resetpass',
	templateUrl: './resetpass.component.html'
})

export class ResetpassComponent {
	public form : FormGroup;
	public load : boolean;
	@Output() finished = new EventEmitter<boolean>();

	constructor(
		private _resetpassService: ResetpassService,
		public toastr: ToastsManager,
		private logger : Logger,
		private fb : FormBuilder
	){

		this.load = false;
		this.form = this.fb.group({
	      email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')]]
	    });
	}


	getFinished() {
		return this.finished;
	}

	onReset() {
		this.load = true; // loading screen

		this.logger.log(this.form.value);

		this._resetpassService.resetpass(this.form.value).subscribe(
			data => {
				if(data.status){
					this.toastr.success('Una nueva contraseña ha sido enviada a su correo electrónico!', '¡Éxito!');
					this.finished.emit(true);
				} else {
					this.toastr.error(data.message, 'Error');
				}
				this.load = false;
			},
			error => {
				this.load = false;
				this.logger.log(error);
				this.toastr.error('El correo es inválido, inténtalo de nuevo', 'Error');
			}
		);

	}

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/auth/resetpass/resetpass.component.ts